import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  postMessage: null,
  postError: null,
  data: undefined,
};

const postHomeFormFourSlice = createSlice({
  name: "postHomeFormFour",
  initialState,
  reducers: {
    postHomeFormFourStart(state, payload) {
      state.loading = true;
      state.postError = null;
      state.postMessage = null;
    },

    postHomeFormFourSuccess(state, action) {
      state.loading = false;
      state.data = action.payload;
      state.postMessage = action.payload.postMessage;
    },
    postHomeTwoDataSuccess(state, action) {
      state.postData = action.payload;
    },
    postHomeFormFourFailure(state, action) {
      state.loading = false;
      state.postError = action.payload;
      state.postMessage = null;
    },

    clearMessage: (state) => {
      state.postError = null;
      state.postMessage = null;
    },
  },
});

export const {
  postHomeFormFourStart,
  postHomeFormFourSuccess,
  postHomeFormFourFailure,
  postHomeTwoDataSuccess,
  clearError,
  clearMessage,
} = postHomeFormFourSlice.actions;

export default postHomeFormFourSlice.reducer;
